import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils/formatText';
import {CalendarEvent} from 'presentation/pages/private/home/components/SaveToCalendar/types';

const {appointmentEventinfo, warningContentTelemedicine} =
	translations['pt-br'].privateFlow.bookingFlow;

interface CalendarEventFormatterProps {
	eventTitle: string;
	specialty: string;
	date: Date;
	providerName: string;
	specialistName: string;
	address: string;
	isTelehealth: boolean;
}

export function calendarEventFormatter({
	date,
	eventTitle,
	address,
	providerName,
	specialistName,
	specialty,
	isTelehealth,
}: CalendarEventFormatterProps): CalendarEvent {
	const appointmentEvent = {
		title: `${eventTitle} ${formatText(specialty)}`,
		startDate: date,
		durationInMinutes: 15,
		description: isTelehealth
			? warningContentTelemedicine
			: `${formatText(providerName)} - ${formatText(
					specialistName,
				)}\n\n${appointmentEventinfo}`,
		address,
	};
	return appointmentEvent;
}
